import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import { SECTION_TYPES_VS_RENDERER_TYPE } from '@src/SectionRenderer/SectionRenderer'

import FlatPartnerProductList from '../partnerPDPLandingPage/sections/flatPartnerProductList'
import NewArrivalProductList from '../partnerPDPLandingPage/sections/newArrivalProductList'
import PartnerPdpLandingForm from '../partnerPDPLandingPage/sections/partnerPdpLandingForm'
import RecommendedProductList from '../partnerPDPLandingPage/sections/recommendedProductList'

export const ADDITIONAL_CUSTOM_SECTIONS: SECTION_TYPES_VS_RENDERER_TYPE = {
  [CUSTOM_SECTION_TYPE.PARTNER_PDP_LANDING_FORM]: PartnerPdpLandingForm,
  [CUSTOM_SECTION_TYPE.RECOMMENDED_PRODUCT_LIST]: RecommendedProductList,
  [CUSTOM_SECTION_TYPE.NEW_ARRIVAL_PRODUCT_LIST]: NewArrivalProductList,
  [CUSTOM_SECTION_TYPE.PARTNER_FLAT_PRODUCT_LIST]: FlatPartnerProductList,
}
